<template>
    <div class="d-flex flex-column align-items-center pt-3 pb-1">
        <div class="spinner-border text-success mb-3" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        <span class="font-xs font-weight-medium text-gray-dk">Wait a moment while we load this for you...</span>
    </div>
</template>
<script>
export default {
    created() {
        let vm = this;
        window.addEventListener('loading', function(e) {
            if(!e.detail) {
                vm.$attrs.options.promiseResolver();
                vm.$listeners.close();
            }
        })
    }
}
</script>